import { render, staticRenderFns } from "./BudgetImporterView.vue?vue&type=template&id=65ca58e1&"
import script from "./BudgetImporterView.vue?vue&type=script&lang=js&"
export * from "./BudgetImporterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports